export interface VideoProject {
  id: string;
  title: string;
  company: string;
  videoUrl: string;
  thumbnailUrl: string;
  originalSize?: string;
}

export interface Client {
  name: string;
  logo: string;
  category: string;
}

// Real portfolio data from R2 storage - simplified
export const SAMPLE_PROJECTS: VideoProject[] = [
  {
    id: '0',
    title: 'LlamaCloud Launch',
    company: 'LlamaIndex',
    videoUrl: 'https://pub-003309fdd9774f75878522f51bf05899.r2.dev/Featured/LlamaCloud%20Launch_3.mp4',
    thumbnailUrl: 'https://pub-003309fdd9774f75878522f51bf05899.r2.dev/Featured/LlamaCloud%20Launch_3.mp4',
    originalSize: '457.92 MB'
  },
  {
    id: '1',
    title: 'Cemex x LlamaIndex',
    company: 'LlamaIndex',
    videoUrl: 'https://pub-003309fdd9774f75878522f51bf05899.r2.dev/LlamaIndex/Final%20Cemex%20x%20Llama_3/hls/playlist.m3u8',
    thumbnailUrl: 'https://pub-003309fdd9774f75878522f51bf05899.r2.dev/LlamaIndex/Final%20Cemex%20x%20Llama_3.mp4',
    originalSize: '285.33 MB'
  },
  {
    id: '13',
    title: 'A1 Base Demo',
    company: 'A1 Base',
    videoUrl: 'https://pub-003309fdd9774f75878522f51bf05899.r2.dev/A1%20Base/x-downloader.com_5Jv3Mu/hls/playlist.m3u8',
    thumbnailUrl: 'https://pub-003309fdd9774f75878522f51bf05899.r2.dev/A1%20Base/x-downloader.com_5Jv3Mu.mp4',
    originalSize: '8.53 MB'
  },
  {
    id: '11',
    title: 'Build Club Demo',
    company: 'Build Club',
    videoUrl: 'https://pub-003309fdd9774f75878522f51bf05899.r2.dev/Build%20Club/1742852925988/hls/playlist.m3u8',
    thumbnailUrl: 'https://pub-003309fdd9774f75878522f51bf05899.r2.dev/Build%20Club/1742852925988.mp4',
    originalSize: '6.1 MB'
  },
  {
    id: '2', 
    title: 'CRODA Interview Part II',
    company: 'CRODA x Hult',
    videoUrl: 'https://pub-003309fdd9774f75878522f51bf05899.r2.dev/CRODA%20x%20Hult%20/CRODA_Interview_Part2/hls/playlist.m3u8',
    thumbnailUrl: 'https://pub-003309fdd9774f75878522f51bf05899.r2.dev/CRODA%20x%20Hult%20/CRODA_Interview_Part2.mp4',
    originalSize: '7398.17 MB'
  },
  {
    id: '3',
    title: 'CRODA Interviews Part I',
    company: 'CRODA x Hult',
    videoUrl: 'https://pub-003309fdd9774f75878522f51bf05899.r2.dev/CRODA%20x%20Hult%20/CRODA_Interviews_Part1/hls/playlist.m3u8',
    thumbnailUrl: 'https://pub-003309fdd9774f75878522f51bf05899.r2.dev/CRODA%20x%20Hult%20/CRODA_Interviews_Part1.mp4',
    originalSize: '5534.42 MB'
  },
  {
    id: '4',
    title: 'Bohdan Interview',
    company: 'Quantum Synesis',
    videoUrl: 'https://pub-003309fdd9774f75878522f51bf05899.r2.dev/Quantum%20Synesis/Bohdan_Interview_Final/hls/playlist.m3u8',
    thumbnailUrl: 'https://pub-003309fdd9774f75878522f51bf05899.r2.dev/Quantum%20Synesis/Bohdan_Interview_Final.mp4',
    originalSize: '516.34 MB'
  },
  {
    id: '5',
    title: 'Erick Interview',
    company: 'Quantum Synesis',
    videoUrl: 'https://pub-003309fdd9774f75878522f51bf05899.r2.dev/Quantum%20Synesis/Erick%20Interview/hls/playlist.m3u8',
    thumbnailUrl: 'https://pub-003309fdd9774f75878522f51bf05899.r2.dev/Quantum%20Synesis/Erick%20Interview.mp4',
    originalSize: '1256.95 MB'
  },
  {
    id: '6',
    title: 'Intro QuantumNoesis',
    company: 'Quantum Synesis',
    videoUrl: 'https://pub-003309fdd9774f75878522f51bf05899.r2.dev/Quantum%20Synesis/Intro_QuantumNoesis2/hls/playlist.m3u8',
    thumbnailUrl: 'https://pub-003309fdd9774f75878522f51bf05899.r2.dev/Quantum%20Synesis/Intro_QuantumNoesis2.mov',
    originalSize: '703.78 MB'
  },
  {
    id: '7',
    title: 'Landing Page Demo',
    company: 'Melo Demo',
    videoUrl: 'https://pub-003309fdd9774f75878522f51bf05899.r2.dev/Melo%20Demo/Landing%20page/hls/playlist.m3u8',
    thumbnailUrl: 'https://pub-003309fdd9774f75878522f51bf05899.r2.dev/Melo%20Demo/Landing%20page.mp4',
    originalSize: '376.08 MB'
  },
  {
    id: '8',
    title: 'Profile Demo',
    company: 'Melo Demo',
    videoUrl: 'https://pub-003309fdd9774f75878522f51bf05899.r2.dev/Melo%20Demo/Profile_1/hls/playlist.m3u8',
    thumbnailUrl: 'https://pub-003309fdd9774f75878522f51bf05899.r2.dev/Melo%20Demo/Profile_1.mp4',
    originalSize: '548.88 MB'
  },
  {
    id: '9',
    title: 'Topics Page Demo',
    company: 'Melo Demo',
    videoUrl: 'https://pub-003309fdd9774f75878522f51bf05899.r2.dev/Melo%20Demo/Topics%20Page%20copy/hls/playlist.m3u8',
    thumbnailUrl: 'https://pub-003309fdd9774f75878522f51bf05899.r2.dev/Melo%20Demo/Topics%20Page%20copy.mov',
    originalSize: '333.5 MB'
  },
  {
    id: '10',
    title: 'Video Upload Demo',
    company: 'Melo Demo',
    videoUrl: 'https://pub-003309fdd9774f75878522f51bf05899.r2.dev/Melo%20Demo/video%20upload/hls/playlist.m3u8',
    thumbnailUrl: 'https://pub-003309fdd9774f75878522f51bf05899.r2.dev/Melo%20Demo/video%20upload.mp4',
    originalSize: '237.33 MB'
  },
  {
    id: '12',
    title: 'Cybersecurity',
    company: 'ITM 4 Architects',
    videoUrl: 'https://pub-003309fdd9774f75878522f51bf05899.r2.dev/ITM%204%20Architechs/yt1z.net%20-%20The%20Best%20Cybersecurity%20Video%20Series%20for%20Architects%2C%20Designers%20and%20Contractors%20is%20ITM%204%20Architects%20(1080p60)/hls/playlist.m3u8',
    thumbnailUrl: 'https://pub-003309fdd9774f75878522f51bf05899.r2.dev/ITM%204%20Architechs/yt1z.net%20-%20The%20Best%20Cybersecurity%20Video%20Series%20for%20Architects%2C%20Designers%20and%20Contractors%20is%20ITM%204%20Architects%20(1080p60).mp4',
    originalSize: '96.16 MB'
  }
];

export const SAMPLE_CLIENTS: Client[] = [
  { name: 'LlamaIndex', logo: '/logos/LlamaIndex.png', category: 'AI Startup' },
  { name: 'CRODA x Hult', logo: '/api/placeholder/120/60', category: 'Business Education' },
  { name: 'Quantum Synesis', logo: '/api/placeholder/120/60', category: 'Quantum Computing' },
  { name: 'Melo Demo', logo: '/api/placeholder/120/60', category: 'Video Sharing Platform' },
  { name: 'Build Club', logo: '/api/placeholder/120/60', category: 'Development Platform' },
  { name: 'ITM 4 Architects', logo: '/api/placeholder/120/60', category: 'Architecture & Design' },
  { name: 'A1 Base', logo: '/api/placeholder/120/60', category: 'AI Platform' }
];
